import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

import { routing } from './dashboard.routing';

import { DashboardComponent } from './dashboard.component';
import { DashboardService } from './dashboard.service';
import { ProfitComponent } from './profit/profit.component';
import { ProfitPortfolioComponent } from './profit-portfolio/profit-portfolio.component';
import { PortfolioChartComponent } from './portfolio-chart/portfolio-chart.component';
import { DropdownModule } from 'primeng/dropdown';
import { TimeConditionComponent } from './time-condition/time-condition.component';
import { PortfolioChartBaseComponent } from './portfolio-chart-base/portfolio-chart-base.component';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [
    DashboardComponent,
    ProfitComponent,
    ProfitPortfolioComponent,
    PortfolioChartComponent,
    PortfolioChartBaseComponent,
    TimeConditionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    SkeletonModule,
    routing,
  ],
  providers: [DashboardService, DatePipe, DecimalPipe],
})
export class DashboardModule {}
